import { render } from "./TimemarkingFooter.vue?vue&type=template&id=709c1de2&scoped=true"
import script from "./TimemarkingFooter.vue?vue&type=script&lang=js"
export * from "./TimemarkingFooter.vue?vue&type=script&lang=js"

import "./TimemarkingFooter.vue?vue&type=style&index=0&id=709c1de2&scoped=true&lang=css"

import exportComponent from "/Users/cn7ero/workspace/timemarking/website/db.timemarking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709c1de2"]])

export default __exports__